// extracted by mini-css-extract-plugin
module.exports = {"profileProjects":"ProfileProjects_profileProjects__Kcsyt"};